import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "profile",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.USERPROFILE.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.USERPROFILE.PERMISSIONS,
    },
    component: () => import("@/modules/Profile/view/profile.vue"),
  },
  {
    path: PATH.CHANGE_PASSWORD,
    name: "changeProfile",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.USERPROFILE.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.USERPROFILE.PERMISSIONS,
    },
    component: () => import("@/modules/Profile/view/changeProfile.vue"),
  },
];

export default routes;
